import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

export const Container = styled(Stack)`
    width: 100%;
    background: ${colorsPalettes.carbon[0]};
    padding: 16px;
    align-items: center;
    border-radius: 6px;
`;

export const TextContainer = styled(Stack)`
    align-items: center;
    gap: 8px;
`;
